import * as classNames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Icon, { IconType } from '../../atoms/Icon/Icon'
import TextLabel, { ColorType, SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import * as styles from './ResultBadge.css'

export enum QuizResult {
  CORRECT,
  FAILURE
}

interface ResultBadgeProps {
  type: QuizResult
}

const ResultBadge: React.FunctionComponent<ResultBadgeProps> = ({ type }) => {
  let icon = <div />
  let text = ''
  let resultClass = ''

  if (type === QuizResult.CORRECT) {
    icon = <Icon iconType={IconType.MARU_WHITE} />
    text = '正解'
    resultClass = styles.correct
  } else {
    icon = <Icon iconType={IconType.BATSU_WHITE} />
    text = '不正解'
    resultClass = styles.failure
  }

  return (
    <div className={classNames(styles.badge, resultClass)}>
      {icon}
      <TextLabel color={ColorType.WHITE} weight={WeightType.HEAVY} size={SizeType.LARGE}>
        {text}
      </TextLabel>
    </div>
  )
}

export default compose<ResultBadgeProps, ResultBadgeProps>(pure)(ResultBadge)
